export default __webpack_public_path__ + "static/media/Major Rune Stone of Unholy Communion (V).ca31e7e6.jpg";